import React from 'react';
import { connect } from 'react-redux';
import { Modal, Text, i18n, tokens } from '@simplybenefits/sb-ui-library';
import * as dates from '@simplybenefits/sb-dates';
import PhotoGrid from '../PhotoGrid';
import pdfReceiptImage from '../../../assets/pdf.png';

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const ReviewClaimModal = ({ 
    submitClaim, 
    onClose, 
    onBack, 
    loader,
    title,
    meta,
    receiptPhoto,
    supportingPhotos
}) => {
    const { patient, category, service, serviceDate, serviceLength, provider, amountSubmitted } = meta;
    const styles = {
        metaBlock: {
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'row',
            paddingBottom: 2
        },
        block: {
            paddingBottom: 10
        },
        receiptPhoto: {
            height: 200,
            width: 'auto',
            alignSelf: 'center',
            backgroundColor: 'transparent',
            marginTop: 10,
            display: 'block',
            margin: 'auto'
        }
    };

    return (
        <Modal
            testid="submit-receipt-modal"
            aria-labelledby="Submit receipt"
            open={true}
            onClose={ onClose }
            title={ title }
            onBack={ onBack }
            loader={ loader }
            primaryButton={{
                label: i18n.t(tokens.buttons.submit),
                onClick: submitClaim
            }}
        >
            <div style={ styles.metaBlock }>
                <Text
                    light
                    mediumLarge
                    flex={1}
                >
                    { i18n.t(tokens.labels.claims.patient) }:
                </Text>

                <Text mediumLarge>{ patient.name }</Text>
            </div>

            <div style={ styles.metaBlock }>
                <Text
                    light
                    mediumLarge
                    flex={1}
                >
                    { i18n.t(tokens.labels.claims.category) }:
                </Text>

                <Text mediumLarge>{ category }</Text>
            </div>

            <div style={ styles.metaBlock }>
                <Text
                    light
                    mediumLarge
                    flex={1}
                >
                    { i18n.t(tokens.labels.claims.service) }:
                </Text>

                <Text mediumLarge>{ service }</Text>
            </div>

            <div style={ styles.metaBlock }>
                <Text
                    light
                    mediumLarge
                    flex={1}
                >
                    { i18n.t(tokens.labels.claims.serviceDate) }:
                </Text>

                <Text mediumLarge>{ dates.getLocalDisplay(serviceDate) }</Text>
            </div>

            <div style={ styles.metaBlock }>
                <Text
                    light
                    mediumLarge
                    flex={1}
                >
                    { i18n.t(tokens.labels.claims.amount) }:
                </Text>

                <Text mediumLarge>${ amountSubmitted }</Text>
            </div>

            <div style={ styles.block }>
                <Text
                    light
                    mediumLarge
                    display="block"
                    customStyle={{ paddingBottom: 10 }}
                >
                    { i18n.t(tokens.labels.claims.receiptInvoice) }:
                </Text>

                {
                    receiptPhoto.file.type === 'application/pdf' ?
                        <img alt="Receipt" src={ pdfReceiptImage } style={ styles.receiptPhoto } />
                        :
                        <img alt="Receipt" src={ receiptPhoto.image } style={ styles.receiptPhoto } />
                }

            </div>

            <div style={ styles.block }>
                <Text
                    light
                    mediumLarge
                    marginBottom={ 5 }
                    display="block"
                >
                    { i18n.t(tokens.labels.claims.supportingDocuments) }:
                </Text>

                {
                    supportingPhotos && supportingPhotos.length > 0 ?
                        <PhotoGrid
                            photos={ supportingPhotos }
                        />
                        :
                        <Text
                            light
                            small
                        >
                            { i18n.t(tokens.labels.claims.noSupportingDocuments) }
                        </Text>
                }
            </div>

            <Text light tiny>
                { i18n.t(tokens.labels.claims.claimAgreementScreen2) }
            </Text>
        </Modal>
    );
};

export default connect()(ReviewClaimModal);